module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman_Ocean.f64b47e6.png";